import { render, staticRenderFns } from "./ModifyBookAndChapter.vue?vue&type=template&id=5873216f&scoped=true"
import script from "./ModifyBookAndChapter.vue?vue&type=script&lang=js"
export * from "./ModifyBookAndChapter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5873216f",
  null
  
)

export default component.exports